import { Link as RouterLink } from 'react-router-dom'
import { Box, Flex, Link, Stack, Text } from '@chakra-ui/react'
import { UserSection } from './UserSection'
import { videoTotals } from '../../utils/userDeletion'
import { useTranslation } from '../../i18n'

// What this person submitted from the webapp. Read-only: the event's videos
// page and moderation are where a video is acted on.
export function ContentCard({ user }) {
    const { t } = useTranslation()
    const totals = videoTotals(user)

    return (
        <UserSection id="user-content" title={t('users.content.title')}>
            {totals.videos === 0 ? (
                <Text fontSize="sm" color="var(--mc-text-muted)">{t('users.content.none')}</Text>
            ) : (
                <>
                    <Text color="var(--mc-text)">{t('users.content.summary', totals)}</Text>
                    <Stack gap={2} as="ul" listStyleType="none" m={0}>
                        {user.videos.map((v) => (
                            <Flex as="li" key={v.eventId} gap={3} wrap="wrap" align="baseline">
                                <Box flex="1" minW="160px">
                                    {v.eventName != null ? (
                                        <Link asChild color="var(--mc-text)" fontWeight="500">
                                            <RouterLink to={`/events/${v.eventId}/videos?uid=${encodeURIComponent(user.uid)}`}>{v.eventName || t('users.events.untitled')}</RouterLink>
                                        </Link>
                                    ) : (
                                        <Text color="var(--mc-text-muted)">{t('users.events.missingEvent')}</Text>
                                    )}
                                </Box>
                                <Text fontSize="sm" color="var(--mc-text-muted)">
                                    {t('users.content.counts', v)}
                                </Text>
                            </Flex>
                        ))}
                    </Stack>
                </>
            )}
        </UserSection>
    )
}
